import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  Input,
  ViewChild,
  ViewContainerRef,
  Type,
  OnInit,
  Output,
  EventEmitter
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppRanking } from '../models/mobileAppRanking';
import { GroupType } from '../types/group-type';
import { MainFilterItem } from '../models/mainFilterItem';
import { GridHeader } from '../models/gridHeader';
import { User } from '../../../../models/User';
import { EventBusService } from 'app/services/EventBusService';

@Component({
  selector: 'app-ranking-widget-container',
  template: `
    <ng-container *ngIf="isLocked">
      <div class="circle-lock-cont"><i class="fa fa-lock"></i></div>
    </ng-container>
    <ng-container *ngIf="!isLocked">
      <template #container></template>
    </ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WidgetContainerComponent implements OnInit, AfterViewInit {
  @Input() data: MobileAppRanking;
  @Input() widgetComponent: Type<DataWidgetComponent>;
  @Input() selectedGroup: GroupType;
  @Input() mainFilterItems: MainFilterItem[];
  @Input() key: string;
  @Input() header: GridHeader;
  @Input() reportId: string;
  @Input() format: string;
  @Input() unlockOverride: boolean;
  @ViewChild('container', { read: ViewContainerRef })
  container: ViewContainerRef;

  isAnonymous: boolean = false;
  isFreemium: boolean = false;

  get isLocked() {
    if (this.unlockOverride) return false;

    return (
      (this.header.lockIfFreemium && this.isFreemium) ||
      (this.header.lockIfAnonymous && this.isAnonymous)
    );
  }

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _changeDetector: ChangeDetectorRef,
    private _userService: User,
    private _eventService: EventBusService,
    private user: User
  ) {}

  ngOnInit() {
    this.isAnonymous = this.user.isAnonymous();
    this.isFreemium = this.user.isFreemium();
  }

  ngAfterViewInit(): void {
    if (this.isLocked) {
      // Do Nothing, it'll display lock in template
    } else {
      this.container.clear();
      const componentFactory =
        this._componentFactoryResolver.resolveComponentFactory<DataWidgetComponent>(
          this.widgetComponent
        );
      const componentRef = this.container.createComponent(componentFactory);
      const instance = componentRef.instance;
      instance.data = this.data;
      instance.selectedGroup = this.selectedGroup;
      instance.mainFilterItems = this.mainFilterItems;
      instance.key = this.key;
      instance.header = this.header;
      instance.format = this.format;
      instance.reportId = this.reportId;
      instance.userService = this._userService;
      instance.eventService = this._eventService;
      this._changeDetector.detectChanges();
    }
  }
}
